import { Button } from '@mui/material';
import type { AssistantAction } from './types';

interface ActionButtonProps {
  action: AssistantAction;
  disabled: boolean;
  onAction?: (action: AssistantAction) => void;
}

const VARIANT_BY_ACTION: Record<AssistantAction['type'], 'outlined' | 'contained'> = {
  apply_filter: 'contained',
  navigate_study: 'outlined',
  open_viewer: 'contained',
  select_study: 'outlined',
};

export const ActionButton = ({ action, disabled, onAction }: ActionButtonProps) => (
  <Button
    size="small"
    variant={VARIANT_BY_ACTION[action.type]}
    color={action.type === 'apply_filter' ? 'primary' : 'inherit'}
    onClick={() => onAction?.(action)}
    disabled={disabled}
    sx={{
      textTransform: 'none',
      fontSize: 12,
      py: 0.25,
      borderRadius: 999,
      px: 1.25,
      minWidth: 0,
    }}
  >
    {action.label}
  </Button>
);
